import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DivisionDistrictMapApi } from '../api/division-district-map.api';
import { DivisionDistrictMap, DivisionDistrictMapData } from '../../../interfaces/masters/division-district-map';

@Injectable()
export class DivisionDistrictMapService extends DivisionDistrictMapData {

  constructor(private api: DivisionDistrictMapApi) {
    super();
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  getById(url: string): Observable<DivisionDistrictMap> {
    return this.api.getById(url);
  }

  create(url: string, data: DivisionDistrictMap): Observable<any> {
    return this.api.add(url, data);
  }

  update(url: string, data: DivisionDistrictMap): Observable<any> {
    return this.api.update(url, data);
  }

}
